module.exports = __webpack_public_path__ + "static/img/spring_tab2_select.b768b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab2_select.png
// module id = 358
// module chunks = 32